import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
interface EndAdornmentProps {
  error: boolean;
  showHelpIcon: boolean;
  helpMessage: string;
}
export const EndAdornment: React.FC<EndAdornmentProps> = ({ error, showHelpIcon, helpMessage }) => {
  if (showHelpIcon && !error) {
    return (
      <InputAdornment position="end">
        <Tooltip title={helpMessage} placement="top" arrow>
          <HelpOutlineIcon data-testid="HelpOutlineIcon" fontSize="small" />
        </Tooltip>
      </InputAdornment>
    );
  }
  if (error) {
    return (
      <InputAdornment position="end" sx={{ marginLeft: '12px' }}>
        <ErrorOutlineIcon color={error ? 'error' : 'inherit'} data-testid="ErrorOutlineIcon" fontSize="small" />
      </InputAdornment>
    );
  }
  return null;
};
